module.exports = __webpack_public_path__ + "static/media/Noticias2.199e76fe.svg";